import PathObject from "../objects/path"
import Form from "./base"
import { metaNameSign } from "@/common/util"
import Calc from "@/common/util/calculator"

export default class RoundedSides extends Form {
  protected path(width: number, height: number, rounding?: number) {
    let aw = width * 0.1
    let cmds = []

    if (rounding) {
      const roundDiff = rounding / 2
      const curviness = 0.1
      cmds = [this.pathMoveTo(width / 2 - aw - roundDiff, -(height / 2))] // UR
      cmds.push(
        this.pathCurveAbs(
          width / 2 - aw - roundDiff,
          -(height / 2),
          width / 2 - aw + curviness * roundDiff,
          -(height / 2),
          width / 2 - aw + roundDiff,
          -(height / 2) + roundDiff
        )
      ) // Upper right rounding
      cmds.push(this.pathCurveAbs(width / 2, -(height / 4), width / 2, 0, width / 2, 0)) // RC1
      cmds.push(
        this.pathCurveAbs(
          width / 2,
          height / 4,
          width / 2 - aw + roundDiff,
          height / 2 - roundDiff,
          width / 2 - aw + roundDiff,
          height / 2 - roundDiff
        )
      ) // RC2
      cmds.push(
        this.pathCurveAbs(
          width / 2 - aw + roundDiff,
          height / 2 - roundDiff,
          width / 2 - aw + curviness * roundDiff,
          height / 2,
          width / 2 - aw - roundDiff,
          height / 2
        )
      ) // Lower right rounding
      cmds.push(this.pathLineToAbs(-(width / 2) + aw + roundDiff, height / 2)) // LL
      cmds.push(
        this.pathCurveAbs(
          -(width / 2) + aw + roundDiff,
          height / 2,
          -(width / 2) + aw - curviness * roundDiff,
          height / 2,
          -(width / 2) + aw - roundDiff,
          height / 2 - roundDiff
        )
      ) // Lower left rounding
      cmds.push(this.pathCurveAbs(-(width / 2), height / 4, -(width / 2), 0, -(width / 2), 0)) // LC1
      cmds.push(
        this.pathCurveAbs(
          -(width / 2),
          -(height / 4),
          -(width / 2) + aw - roundDiff,
          -(height / 2) + roundDiff,
          -(width / 2) + aw - roundDiff,
          -(height / 2) + roundDiff
        )
      ) // LC2
      cmds.push(
        this.pathCurveAbs(
          -(width / 2) + aw - roundDiff,
          -(height / 2) + roundDiff,
          -(width / 2) + aw - curviness * roundDiff,
          -(height / 2),
          -(width / 2) + aw + roundDiff,
          -(height / 2)
        )
      ) // Upper left rounding

      cmds.push(this.pathClose())
    } else if (metaNameSign(this.signType)) {
      aw = width * 0.04
      const roundDiff = 3.78
      cmds.push(this.pathMoveTo(width / 2 - aw - roundDiff, -(height / 2))) // UR
      cmds.push(
        this.pathCurveAbs(
          width / 2 - aw - roundDiff,
          -(height / 2),
          width / 2 - aw + 0.6 * roundDiff,
          -(height / 2),
          width / 2 - aw + roundDiff,
          -(height / 2) + roundDiff
        )
      ) // Upper right rounding
      cmds.push(this.pathCurveAbs(width / 2, -(height / 4), width / 2, 0, width / 2, 0)) // RC1
      cmds.push(
        this.pathCurveAbs(
          width / 2,
          height / 4,
          width / 2 - aw + roundDiff,
          height / 2 - roundDiff,
          width / 2 - aw + roundDiff,
          height / 2 - roundDiff
        )
      ) // RC2
      cmds.push(
        this.pathCurveAbs(
          width / 2 - aw + roundDiff,
          height / 2 - roundDiff,
          width / 2 - aw + 0.6 * roundDiff,
          height / 2,
          width / 2 - aw - roundDiff,
          height / 2
        )
      ) // Lower right rounding
      cmds.push(this.pathLineToAbs(-(width / 2) + aw + roundDiff, height / 2)) // LL
      cmds.push(
        this.pathCurveAbs(
          -(width / 2) + aw + roundDiff,
          height / 2,
          -(width / 2) + aw - 0.6 * roundDiff,
          height / 2,
          -(width / 2) + aw - roundDiff,
          height / 2 - roundDiff
        )
      ) // Lower left rounding
      cmds.push(this.pathCurveAbs(-(width / 2), height / 4, -(width / 2), 0, -(width / 2), 0)) // LC1
      cmds.push(
        this.pathCurveAbs(
          -(width / 2),
          -(height / 4),
          -(width / 2) + aw - roundDiff,
          -(height / 2) + roundDiff,
          -(width / 2) + aw - roundDiff,
          -(height / 2) + roundDiff
        )
      ) // LC2
      cmds.push(
        this.pathCurveAbs(
          -(width / 2) + aw - roundDiff,
          -(height / 2) + roundDiff,
          -(width / 2) + aw - 0.6 * roundDiff,
          -(height / 2),
          -(width / 2) + aw + roundDiff,
          -(height / 2)
        )
      ) // Upper left rounding

      cmds.push(this.pathClose())
    } else {
      // plastic sign no rounding
      cmds.push(this.pathMoveTo(-(width / 2) + aw, -(height / 2)))
      cmds.push(this.pathLineToAbs(width / 2 - aw, -(height / 2)))
      cmds.push(this.pathMoveTo(width / 2 - aw, -(height / 2))) // UR
      cmds.push(this.pathCurveAbs(width / 2, -(height / 4), width / 2, 0, width / 2, 0)) // RC1
      cmds.push(this.pathCurveAbs(width / 2, height / 4, width / 2 - aw, height / 2, width / 2 - aw, height / 2)) // RC2
      cmds.push(this.pathLineToAbs(-(width / 2) + aw, height / 2)) // LL
      cmds.push(this.pathCurveAbs(-(width / 2), height / 4, -(width / 2), 0, -(width / 2), 0)) // LC1
      cmds.push(
        this.pathCurveAbs(
          -(width / 2),
          -(height / 4),
          -(width / 2) + aw,
          -(height / 2),
          -(width / 2) + aw,
          -(height / 2)
        )
      ) // LC2
    }

    return new PathObject(cmds.join(""), this.defaultParams)
  }

  protected get cutlineRounding() {
    return this.printCutlineRounding(this.calcRounding())
  }

  private calcRounding() {
    if (["aluminium_sign", "acryl_sign", "acryl_alu_sign"].includes(this.signType)) {
      return Calc.mmToPx(1)
    }

    return 0
  }
}
